import React from 'react';
import { useEffect, useState } from "react";
import "../../styles/collections/collection_details.css";
import ReactTooltip from 'react-tooltip';
import { onAuthStateChanged } from "firebase/auth";
import { firebaseAuth, firebaseFirestore } from "../firebase/firebase_configuration";
import { deleteField, doc, getDoc, onSnapshot, updateDoc } from "firebase/firestore";
import { Link, useLocation, useNavigate } from "react-router-dom";

import backArrowIcon from "../../images/back_arrow_icon_2.png";
import editIcon from "../../images/profile/edit_icon.png";
import deleteIcon from "../../images/chats/delete_icon.png";
import noImage from "../../images/collections/no_image.png";
import { getItem } from "../repositories/movies_and_tvseries";
import EditCollection from "./edit_collection";

const CollectionDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [getOnShowEdit, setOnShowEdit] = useState(false);
    const [getUserId, setUserId] = useState("");
    const [getCollectionName, setCollectionName] = useState("");
    const [getCollectionDescription, setCollectionDescription] = useState("");
    const [getCollectionPrivacy, setCollectionPrivacy] = useState("");
    const [getCollectionItems, setCollectionItems] = useState([]);

    const path = location.pathname.split("/");
    const collectionId = path[path.indexOf("collections") + 1];

    const goBack = () => {
        navigate(-1);
    };

    const onEditCollection = () => {
        setOnShowEdit(true);
    };

    const onDeleteCollection = async () => {
        // eslint-disable-next-line no-restricted-globals
        const shouldDelete = confirm("Are you sure you want to delete this collection?");
        if (shouldDelete) {
            try {
                const userRef = doc(firebaseFirestore, 'User Collections', getUserId);
                const docSnapshot = await getDoc(userRef);
                if (docSnapshot.exists()) {
                    await updateDoc(userRef, {
                        [`${collectionId}`]: deleteField(),
                    }).then((_) => {
                        // goBack();
                    });
                } ;
            } catch (error) {
                alert("Failed to delete collection. Please try again.");
                console.log(error.message); 
            };
        };
    };

    const onRemoveItem = async (itemName, itemId) => {
        // eslint-disable-next-line no-restricted-globals
        const shouldDelete = confirm(`Are you sure you want to remove "${itemName}" from this collection?`);
        if (shouldDelete) {
            try {
                const collectionRef = doc(firebaseFirestore, 'User Collections', getUserId); 
                const collectionDoc = await getDoc(collectionRef);
                if (collectionDoc.exists()) {
                    let collectionMap = collectionDoc.data()[collectionId];
                    if (collectionMap != null) {
                        let itemsList = collectionMap["items"] || [];
                        if (itemsList.includes(itemId)) {
                            itemsList = itemsList.filter(id => id !== itemId);
                        };
    
                        await updateDoc(collectionRef, { [`${collectionId}.items`]: itemsList }, { merge: true });
                    } 
                }
            } catch (error) {
                console.log(error.message);
            };
        };
    };

    const getCollection = async () => {
        try {
            const userRef = doc(firebaseFirestore, 'User Collections', getUserId);
            const scription = onSnapshot(userRef, async (docSnapshot) => {
                if (docSnapshot.exists()) {
                    const collectionsData = docSnapshot.data();
                    let collectionsArray = [];

                    if (collectionsData[collectionId] == null) {
                        navigate("/main_back/collections", {replace: true});
                    };

                    Object.keys(collectionsData).forEach((fieldName) => {
                        if (fieldName === collectionId) {
                            const collection = collectionsData[fieldName];
                            setCollectionName(collection.name);
                            setCollectionDescription(collection.description);
                            setCollectionPrivacy(collection.privacy);
                            collectionsArray = collection.items;
                        };
                    });

                    const itemDetails = await Promise.all(
                        collectionsArray.map(async (item) => {
                            let newGenreList = [];
                            const itemId = item.split("_")[1];
                            const type = item.split("_")[0];
                            const details = await getItem({ itemId, type: type === "movie" ? type : "tv" });

                            details["genres"].forEach((result) => {
                                const isDuplicate = newGenreList.some(item => item.name === result.name);
                                if (!isDuplicate) {
                                    newGenreList.push({
                                        name: result.name,
                                    });
                                }
                            });
                            const genreNames = newGenreList.map(item => item.name);

                            return { 
                                ...item, 
                                id: itemId,
                                name: `${type === "movie" ? details.title : details.name}`,
                                image: details.poster_path,
                                type: type,
                                genre: `${genreNames[0] !== "" || genreNames[0] != null ? genreNames[0].toLowerCase() : "action"}` 
                            };
                        })
                    );

                    setCollectionItems(itemDetails);
                };
            }); 

            return () => scription;
        } catch (error) {
            console.log(error.message); 
        };
    };

    const getCardSpace = () => {
        if (getCollectionItems.length > 0) {
            const parent = document.getElementById('collection_details_screen_grid');
            const parentWidth = parent.offsetWidth;
            const childWidth = window.innerWidth <= 600 ? 110 : 150 + 30;
            const numChildren = Math.floor(parentWidth / childWidth);
            parent.style.gridTemplateColumns = `repeat(${numChildren}, 1fr)`;
        }
    };

    useEffect(() => {
        getCardSpace();
        const handleResize = () => {
            getCardSpace();
        };
    
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [getCollectionItems]);

    useEffect(() => {
        getCollection();
    }, [getUserId])

    useEffect(() => {
        onAuthStateChanged(firebaseAuth, (user) => {
            if (user) {
                setUserId(user.uid);
            }
        });
    }, []); 
    
    // useEffect(() => {
    //     if (collectionId === "" || collectionId === null) {
    //         navigate("/main_back/collections", {replace: true});
    //     }
    // }, [collectionId]);

    return(
        <div className="collection_details_screen">
            <div className="collection_details_screen_header_row">
                <div className="collection_details_screen_header_row_a">
                    <img onClick={goBack} className="home_item_section_back" src={backArrowIcon} />
                    <p className="collection_details_screen_header">{getCollectionName}</p>
                </div>

                <div className="collection_details_screen_header_row_b">
                    <img data-tip data-for="edit_collection" onClick={onEditCollection} className="home_item_section_back" src={editIcon} />
                    <ReactTooltip effect='solid' id="edit_collection" place="top">Edit collection</ReactTooltip>
                    <img data-tip data-for="delete_collection" onClick={onDeleteCollection} className="home_item_section_back" src={deleteIcon} />
                    <ReactTooltip effect='solid' id="delete_collection" place="top">Delete collection</ReactTooltip>
                </div>
            </div>
            <div className="collection_details_screen_block">
                <p data-tip data-for="privacy_description" className="collection_details_screen_privacy">{`${getCollectionPrivacy.charAt(0).toUpperCase()}${getCollectionPrivacy.slice(1)}`}</p>
                <ReactTooltip effect='solid' id="privacy_description" place="top">{`This collection is ${getCollectionPrivacy === "public" ? "visible to all users." : "only visible to you."}`}</ReactTooltip>
                <p className="collection_details_screen_description">{getCollectionDescription}</p>

                {
                    getCollectionItems.length > 0
                    ? <div id="collection_details_screen_grid" className="collection_details_screen_grid">
                        {
                            getCollectionItems.map((item, index) => (
                                <div className="collection_details_screen_item_column">
                                    <Link className="action_container_sub_home_screen_a" to={`/main_back/home/${item.genre}/${item.type}/${item.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={item.image === "" || item.image == null ? noImage : `https://image.tmdb.org/t/p/w500${item.image}`}
                                            alt={item.name}
                                            className="movie_poster"
                                        />
                                        <p className="col_movie_item_p">{item.name}</p>
                                    </div></Link>
                                    <p onClick={() => onRemoveItem(item.name, `${item.type}_${item.id}`)} className="collection_details_screen_remove">remove</p>
                                </div>
                            ))                        
                        }
                    </div>
                    : <div>
                        <p className="collection_details_screen_empty_text">This collection is empty 🥲.</p>
                        <Link to={"/main_back/home"} className="action_container_sub_home_screen_a"><p className="collection_details_screen_empty_link">Add to Collection</p></Link>
                    </div>
                }
            </div>
            {getOnShowEdit && <EditCollection getShow={getOnShowEdit} setShow={setOnShowEdit} collectionId={collectionId} getUserId={getUserId} />}
        </div>
    );
};

export default CollectionDetails;